module.exports = __webpack_public_path__ + "media/leadercoach-1080.f6c3bb19.mp4";